// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper-b7dd","bg-blue":"bg-blue-fe7c"};